import React from 'react';

import * as styled from '../../loading-app.styled';
import { CustomSkeleton } from '@components/loading/custom-skeleton/custom-skeleton';
import { getNavigationWidth } from '@containers/navigation/activity-type-tabs/activity-type-tabs.styled';
import { useFeatureFlag } from '@containers/navigation/activity-type-tabs/hooks/use-feature-flag';
import { useNavigationConfiguration } from '@containers/navigation/hooks/use-navigation-configuration';
import { convertNumberToPx } from '@style/helpers';

export const LoadingNavigation = () => {
    const activityItems = useNavigationConfiguration();
    const { isHiddenFeatureFlag } = useFeatureFlag();
    const visibleItemCount = Math.max(
        activityItems.filter(item => !isHiddenFeatureFlag(item.isHidden)).length,
        1
    );
    const activityTypesWidth = getNavigationWidth(visibleItemCount);

    return (
        <CustomSkeleton
            {...styled.activityTypes}
            width={{
                base: convertNumberToPx(activityTypesWidth.base),
                tablet: convertNumberToPx(activityTypesWidth.tablet)
            }}
        />
    );
};
